export const BirthdayTemplates = {
  formal: {
    afr: "Goeie dag. Baie geluk met jou verjaarsdag. Vriendelike Groete.",
    eng: "Good day. A warm and happy Birthday to you. Kind Regards."
  },
  informal: {
    afr: "Lekker verjaar. Ek hoop dis 'n baie lekker dag en jaar wat voorle.",
    eng: "Happy Birthday. I hope it's a awesome day and year ahead of you."
  },
};


// WEBPACK FOOTER //
// ./src/helpers/BirthdayTemplates.js